module.exports = require("@vue/composition-api");